import React from 'react';
import { useTrainingBar } from '../data';
import BarComponent from './BarComponent';
import ChartLoading from './ChartLoading';
import { BAR_CHART, PIE_CHART, useChartData } from './config';
import PieComponent from './PieComponent';

const Training = ({ loading, training }) => {
  const { trainingBar } = useTrainingBar();

  const data = useChartData({ data: training, type: PIE_CHART, label: 'Jumlah Training' });
  const barData = useChartData({ data: trainingBar, type: BAR_CHART, label: 'Jumlah Training' });

  return (
    <>
      {loading ? <ChartLoading /> : <PieComponent data={data} />}
      {/* <hr />
      Training Tertinggi Perusahaan
      {loading ? <ChartLoading /> : <BarComponent data={barData} />} */}
    </>
  );
}

export default Training;